import { BaseModal } from '@anytag/shared-atoms';
import { useQueryHelper } from '@anytag/shared-hooks';

export interface MissingHubSpotModalProps {
  open?: boolean;
  onClose?: () => void;
  engagementId: number;
}

export const MissingHubSpotModal = ({ open, onClose, engagementId }: MissingHubSpotModalProps) => {
  const { t, navigate, pathname } = useQueryHelper();

  const handleNavigateToCampaignDetails = () => {
    navigate({
      to: '/engagement/$id',
      params: { id: engagementId.toString() },
      search: { state: { redirectUrlAfterUpdateEngagement: pathname } }
    });
    onClose?.();
  };

  return (
    <BaseModal
      open={open}
      onClose={onClose}
      title={t('Set HubSpot deal')}
      description={t('You need to set HubSpot deal in order to approve this campaign')}
      footer={{
        cancelButton: { onClick: onClose },
        submitButton: { onClick: handleNavigateToCampaignDetails }
      }}
    />
  );
};
